import React from 'react';
import PropTypes from 'prop-types';
import { ButtonWithIcon } from '@els/els-react--button';

export default class Header extends React.PureComponent {
  render() {
    const { isEditMode, isMigrateMode, id, selfClose = () => {} } = this.props;

    let titleText = 'Create';
    if (isEditMode) {
      titleText = 'Edit';
    } else if (isMigrateMode) {
      titleText = 'Migrate';
    }

    return (
      <>
        <h3 id={id} className="create-alert-dialog-title">
          {titleText} alert
        </h3>
        <ButtonWithIcon
          data-e2e="close-alert"
          type="borderless"
          size="small"
          sprite="Close"
          iconRight
          iconOnly
          className="create-alert-dialog-close"
          aria-label={`Close ${titleText.toLowerCase()} alert dialog`}
          onClick={selfClose}>
          Close {titleText.toLowerCase()} alert dialog
        </ButtonWithIcon>
      </>
    );
  }
}

Header.propTypes = {
  isEditMode: PropTypes.bool,
  isMigrateMode: PropTypes.bool,
  id: PropTypes.string,
  selfClose: PropTypes.func,
};
